<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface DataListItemActionsProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  const props = defineProps<DataListItemActionsProps>()
</script>

<template>
  <div :class="cn('shrink-0', props.class)" @click.stop @mousedown.stop>
    <slot />
  </div>
</template>
